import { TrackModel } from "@similarweb/sw-track";

import { handleChiliPiperSubmit } from "./chili";
import { track } from "./track";

(function () {
    const apis = {
        hook: {
            open: {
                key: "string",
                trackId: "string",
                version: "string",
                location: "string",
                currentPageLocation: "string",
                onClose: "function",
            },
            close: {},
            style: {
                style: "object",
            },
        },
    };
    window.SwHook = {
        track: (category, action, name) => track.trackEvent(category, action, name),
        track2: (trackPayload: TrackModel) => track.trackEvent2(trackPayload),
        getFrame: async function (bundle: string, id: string, remoteCaller?: Window) {
            return new Promise<HTMLIFrameElement>((resolve) => {
                const getFrameResult = window.document.getElementById(
                    `__${bundle}${id ? "_" + id : ""}__`,
                ) as HTMLIFrameElement;
                if (remoteCaller) {
                    remoteCaller.postMessage(
                        { op: "get-frame-target", bundle, id, frame: getFrameResult ? { api: apis[bundle] } : null },
                        "*",
                    );
                }
                resolve(getFrameResult);
            });
        },
        destroyFrame: async function (bundle: string, id: string, destroyer?: Window) {
            return new Promise((resolve) => {
                const getFrameResult = window.document.getElementById(
                    `__${bundle}${id ? "_" + id : ""}__`,
                ) as HTMLIFrameElement;
                if (!getFrameResult) {
                    return;
                }
                let handler = null;
                handler = (ev) => {
                    if (ev.data.bundle === bundle && ev.data.id === id) {
                        switch (ev.data.op) {
                            case "frame-destroying":
                                if (!ev.data.allow) {
                                    window.removeEventListener("message", handler);
                                    if (destroyer) {
                                        destroyer.postMessage(
                                            {
                                                op: "destroy-frame-target",
                                                bundle,
                                                id,
                                                allow: false,
                                            },
                                            "*",
                                        );
                                    }
                                    // eslint-disable-next-line no-console
                                    console.log(
                                        `Frame ${bundle} ${id ?? ""} rejected destroy request from ${destroyer?.name ?? "unknown source"}`,
                                    );
                                    resolve(false);
                                    return;
                                } else {
                                    if (getFrameResult.sizer) {
                                        getFrameResult.sizer.observer.disconnect();
                                    }
                                    getFrameResult.remove();
                                }
                                break;
                            case "frame-destroyed":
                                window.removeEventListener("message", handler);
                                destroyer?.postMessage(
                                    {
                                        op: "destroy-frame-target",
                                        bundle,
                                        id,
                                        allow: true,
                                    },
                                    "*",
                                );
                                resolve(true);
                                return;
                        }
                    }
                };
                window.addEventListener("message", handler);
                getFrameResult.contentWindow.postMessage(
                    { op: "frame-destroying", bundle, id, allowCancel: true },
                    "*",
                );
            });
        },
        createFrame: async function (
            bundle: string,
            id: string,
            zorder: number,
            sizingElement: string,
            onSetup: (bundle: string, id: string) => any,
            creator?: Window,
            context?: {},
            topPosition?: string,
        ) {
            return new Promise((resolve) => {
                let handler = null;
                handler = (ev) => {
                    if (ev.data.op === "frame-created" && ev.data.bundle === bundle && ev.data.id === id) {
                        window.removeEventListener("message", handler);
                        if (creator) {
                            creator.postMessage(
                                {
                                    op: "create-frame-target",
                                    bundle,
                                    id,
                                    frame: { api: apis[bundle] },
                                },
                                "*",
                            );
                        }
                        const getFrameResult = window.document.getElementById(
                            `__${bundle}${id ? "_" + id : ""}__`,
                        ) as HTMLIFrameElement;
                        resolve(getFrameResult);
                    }
                };
                window.addEventListener("message", handler);
                installFrame(bundle, id, zorder, sizingElement, context, topPosition);
            });
        },
        error: async function (status: number, description: string) {
            if (status == 401) {
                //todo: other cases
                window.location.reload();
            }
        },
    };

    const eventHookReady = new CustomEvent("SwHookReady", { detail: { op: "SwHookReady" } });
    window.dispatchEvent(eventHookReady);
    function installFrame(
        bundle: string,
        id: string,
        z: number,
        s: string,
        context: {},
        topPosition: string,
    ): HTMLIFrameElement {
        const iframe = document.createElement("iframe");
        iframe.id = iframe.name = id ? `__${bundle}_${id}__` : `__${bundle}__`;
        //window.SwHook.observers[iframe.id] = {frame: iframe, observer: null }
        iframe.allow = "fullscreen";
        // @ts-ignore
        iframe.allowtransparency = true;
        // iframe.scrolling = "no";
        // @ts-ignore
        iframe.style.position = "absolute";
        iframe.style.borderWidth = "0px";
        iframe.style.zIndex = `${z ?? 2000}`;
        iframe.style.width = "0px";
        iframe.style.height = "0px";
        iframe.setAttribute("aria-hidden", "true");
        iframe.src = `{{hooks_frame_path}}/${bundle}.html${context ? "?" + new URLSearchParams(context).toString() : ""}`;
        const observer = new ResizeObserver((a, observer) => {
            const rect = a[0].target.getBoundingClientRect();
            const frame = observer.source;
            frame.style.top = `${topPosition ? 0 - rect.top : rect.top}px`;
            frame.style.left = `${rect.left}px`;
            frame.style.width = `${rect.right - rect.left}px`;
            frame.style.height = `${topPosition ?? rect.bottom - rect.top}px`;
        });
        observer.source = iframe;
        let sizerTarget = null;
        if (s) {
            sizerTarget = window.document.getElementById(s);
        }
        iframe.sizer = {
            observer: observer,
            target: sizerTarget ?? document.body,
        };
        if (apis[bundle]) {
            iframe.api = {};
            for (const prop in apis[bundle]) {
                const method = function () {
                    this.contentWindow.postMessage(
                        {
                            op: prop,
                            bundle: bundle,
                            id: this.id,
                            // eslint-disable-next-line prefer-rest-params
                            data: arguments.length > 0 ? { ...arguments[0] } : null,
                        },
                        "*",
                    );
                };
                iframe.api[prop] = method.bind(iframe);
            }
        }
        document.body.appendChild(iframe);
        return iframe;
    }

    window.addEventListener("message", async (a) => {
        const data = a.data;
        if (!data.op) {
            return;
        }
        let frameWindow: Window;
        let frameElement: HTMLIFrameElement;

        switch (data.op) {
            case "chili-submit":
                handleChiliPiperSubmit(a);
                break;
            case "track":
                track.trackEvent(data.category, data.action, data.name);
                break;
            case "track2":
                track.trackEvent2(data.trackModel);
                break;
            case "error":
                frameWindow = a.source as Window;
                if (!frameWindow) {
                    return;
                }
                await window.SwHook.error(data.status, data.description);
                break;
            case "create-frame":
                frameWindow = a.source as Window;
                if (!frameWindow) {
                    return;
                }
                await window.SwHook.createFrame(
                    data.bundle,
                    data.id,
                    data.zorder,
                    data.sizer,
                    null,
                    frameWindow,
                    data.context,
                );
                break;
            case "close-frame": {
                const event = new CustomEvent("onHookClose", { detail: data });
                window.dispatchEvent(event);
                break;
            }
            case "open": {
                const eventHookInstalled = new CustomEvent("SwHookOpenFrame", { detail: { op: "SwHookOpenFrame" } });
                window.dispatchEvent(eventHookInstalled);
                break;
            }
            case "open-premium-hook":
                frameElement = window.document.getElementById(
                    `__${data.bundle}${data.id ? "_" + data.id : ""}__`,
                ) as HTMLIFrameElement;
                if (!frameElement) {
                    return;
                }
                //location interception point
                if (data.data && !data.data.currentPageLocation) {
                    data.data.currentPageLocation = window.location.href;
                }
                data.op = "open";
                frameElement.contentWindow.postMessage(data, "*");
                break;
            case "destroy-frame":
                frameWindow = a.source as Window;
                if (!frameWindow) {
                    return;
                }
                await window.SwHook.destroyFrame(data.bundle, data.id, frameWindow);
                break;
            case "get-frame":
                frameWindow = a.source as Window;
                if (!frameWindow) {
                    return;
                }
                await window.SwHook.getFrame(data.bundle, data.id, frameWindow);
                break;
            case "size":
                frameElement = window.document.getElementById(
                    `__${data.bundle}${data.id ? "_" + data.id : ""}__`,
                ) as HTMLIFrameElement;
                if (!frameElement || !frameElement.sizer) {
                    return;
                }

                if (data.enable) {
                    frameElement.sizer.observer.observe(frameElement.sizer.target);
                } else {
                    frameElement.sizer.observer.unobserve(frameElement.sizer.target);
                    frameElement.style.top =
                        frameElement.style.left =
                        frameElement.style.width =
                        frameElement.style.height =
                            "0px";
                }
                break;
            case "frame-destroyed":
                // eslint-disable-next-line no-console
                console.log(`Frame ${data.bundle} ${data.id ?? ""} destroyed`);
                break;
            case "frame-created":
                // eslint-disable-next-line no-console
                console.log(`Frame ${data.bundle} ${data.id ?? ""} created`);
                break;
            default:
                frameElement = window.document.getElementById(
                    `__${data.bundle}${data.id ? "_" + data.id : ""}__`,
                ) as HTMLIFrameElement;
                if (!frameElement) {
                    return;
                }
                //location interception point
                if (data.data && !data.data.currentPageLocation) {
                    data.data.currentPageLocation = window.location.href;
                }
                frameElement.contentWindow.postMessage(data, "*");
                break;
        }
    });
})();
